export function tableViewSize(allSize) {
  const size = [
    {
      label: 5,
      value: 5,
    },
    {
      label: 15,
      value: 15,
    },
    {
      label: 25,
      value: 25,
    },
    {
      label: 35,
      value: 35,
    },
    {
      label: 45,
      value: 45,
    },
    {
      label: 55,
      value: 55,
    },
    {
      label: 65,
      value: 65,
    },
    {
      label: 75,
      value: 75,
    },
    {
      label: 85,
      value: 85,
    },
    {
      label: 95,
      value: 95,
    },
    {
      label: 100,
      value: 100,
    },
    {
      label: 'All',
      value: allSize || 999,
    },
  ]

  return size
}
